var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecrypt0106(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34DAE2;}\n\t.st1{fill:#252A41;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#252A41;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logotype",
    transform: "translate(0.762 142.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    transform: "translate(0 1.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    className: "st1",
    d: "M2.52-138.35v6.61h8.06v-7.77L2.52-138.35z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    transform: "translate(9.213 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    className: "st1",
    d: "M2.52-138.19v7.94h9.21v-9.26L2.52-138.19z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    transform: "translate(9.213 10.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    className: "st1",
    d: "M2.52-139.51v7.94l9.21,1.32v-9.26H2.52z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    transform: "translate(0 10.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    className: "st1",
    d: "M2.52-139.51v6.61l8.06,1.16v-7.77H2.52z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecrypt0106);
export default __webpack_public_path__ + "static/media/recrypt_01-06.ec85c379.svg";
export { ForwardRef as ReactComponent };